//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionDownload(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18 13.27V10.66L13 14.86V5H11V14.86L6 10.66V13.27L12 18.27L18 13.27ZM3 20V22H21V20H3Z" fill="currentColor" /></svg>;
}
export default IconActionDownload;